import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: transparent;
  max-height: 302px;
  overflow-y: auto;
`;
